import React from 'react'
import styled from '@emotion/styled'
import { loadFromLocalStorage, saveToLocalStorage } from '../../store'

const Upload = styled.span`
  color: rgba(0, 0, 0, 0.87);
`
const Bold = styled.span`
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
`

const ClearLS = () => {
  const click = () => {
    // eslint-disable-next-line no-undef
    const ok = window.confirm('Are you sure you want to clear LocalStorage?')
    if (ok) {
      saveToLocalStorage(loadFromLocalStorage)
    }
  }

  return (
    <Upload onClick={click}>
      <Bold>Clear LocalStorage</Bold> (reload page after clearing)
    </Upload>
  )
}
export default ClearLS
